<template>
  <div class="kiaf-frameset">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'KiafFrameset',
    methods: {
      resize () {
        let fontSize = document.body.clientWidth / (1920 / 20);
        document.documentElement.style.fontSize = fontSize + 'px';
      }
    },
    created() {
      // 根据窗口大小变换页面自适应
      this.resize();
      window.addEventListener('resize', this.resize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.resize);
    }
  };
</script>
<style lang="scss">
  .kiaf-frameset {
    width: 100%;
    height: 100%;
    padding: 0px;
    margin: 0px;
  }
  html, body {
    width: 100%;
    height: 100%;
    background: #f8f8fc;
  }
  * {
    padding: 0;
    margin: 0;
  }
</style>
